export default __webpack_public_path__ + "static/media/sala01.d7907c55.png";